export function getTenantTranslation(t, tenantType, key) {
  if (typeof t !== 'function') return key;

  const normalizedTenantType = tenantType ? tenantType.toUpperCase() : null;

  if (!normalizedTenantType) {
    return t(key);
  }

  const tenantValue = t(`tenantDomain.${normalizedTenantType}.${key}`, {
    defaultValue: '',
  });

  if (tenantValue) {
    return tenantValue;
  }

  return t(key);
}